import type { DocumentEntity } from '@api/types/document';

/**
 * Whether the caller may pick this document as the source of a "replace with existing".
 * The swap deletes the source, so it takes the owner or editor role that
 * `DELETE /audit/:id/documents/:docId` requires (#670): today an auditor of the audit or
 * the document's uploader. Client lists carry `canManageSignatures` (their
 * `myAccess.role` is always `read_only`); auditor lists carry the real role.
 */
export const canUseAsReplaceSource = (
  doc: Pick<DocumentEntity, 'canManageSignatures' | 'myAccess'>,
): boolean => doc.canManageSignatures ?? ['owner', 'editor'].includes(doc.myAccess?.role ?? '');
